import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { map, take } from 'rxjs';
import { consumePreviewReturnUrl, rememberPreviewReturnUrl, validatePreviewReturnUrl } from './preview-return-url';

export function externalLoginGuard(route: ActivatedRouteSnapshot) {
  const auth = inject(AuthService);
  const returnUrl = validatePreviewReturnUrl(route.queryParamMap.get('returnUrl'));
  if (returnUrl) {
    rememberPreviewReturnUrl(returnUrl);
  }

  return auth.user.pipe(
    take(1),
    map(user => {
      if (user && auth.isSupportUser(user)) {
        const previewReturn = consumePreviewReturnUrl();
        if (previewReturn) {
          window.location.assign(previewReturn);
          return false;
        }
        return auth.getHomeUrlTree(user);
      }
      return true;
    })
  );
}
